import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import toast from './views/mall/components/common/toast'
import {jQuery} from "./assets/js/jquery-3.3.1.min";
import {rem} from "./assets/js/rem";
// Vue.use(jQuery)
// Vue.use(rem)
Vue.config.productionTip = false
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
Vue.use(MintUI);
Vue.prototype.$bus=new Vue();

Vue.prototype.$bus=new Vue();
import { Header } from 'mint-ui';

Vue.component(Header.name, Header);

Vue.use(toast);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
